module.exports = __webpack_public_path__ + "img/flicker_left.55e8c8a4.gif";